import React from 'react';
import { CruisesWrapper } from '../../components/cruises';

interface IProps {}

export class CruisesPage extends React.Component<IProps> {
  render(): React.ReactNode {
    return <CruisesWrapper />;
  }
}
